import { render, staticRenderFns } from "./OutlinedLabel.vue?vue&type=template&id=7f98a6da&scoped=true&lang=pug&"
import script from "./OutlinedLabel.vue?vue&type=script&lang=js&"
export * from "./OutlinedLabel.vue?vue&type=script&lang=js&"
import style0 from "./OutlinedLabel.vue?vue&type=style&index=0&id=7f98a6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98a6da",
  null
  
)

export default component.exports